// @flow

import * as React from 'react';
import {useState} from 'react';
import {ReactFlowProvider} from 'react-flow-renderer';
import {OnlyRenderOnClient} from 'docs/components';
import Box from 'sail/Box';
import {DiagramContent} from './DiagramContent';
import type {DiagramType} from './types';
import './Diagram.scss';

type DiagramProps = {|
  type: DiagramType,
  description: string,
  elements: Array<any>,
|};

const DiagramLoadingSkeleton = () => (
  <Box className="Diagram--loading" background="gray100">
    <Box className="Diagram--loading-overlay" background="surface" />
  </Box>
);

export const Diagram = ({type, description, elements}: DiagramProps) => {
  const [loading, setLoading] = useState(true);
  return (
    <Box className="Diagram" margin={{vertical: 12}}>
      {loading && <DiagramLoadingSkeleton />}
      <OnlyRenderOnClient>
        <ReactFlowProvider>
          <DiagramContent
            type={type}
            description={description}
            initialElements={elements}
            setLoading={setLoading}
          />
        </ReactFlowProvider>
      </OnlyRenderOnClient>
    </Box>
  );
};
